import api from '@/utils/http'

/**
 功能：列表
 time: 2025-13-01 17:13:44
 **/
export function getAuditTypeList(data) {
    return api.post('/admin/auditType/getList', data)
}

/**
 功能：保存
 time: 2025-38-02 16:38:38
 **/
export function saveAuditType(data) {
    return api.post('/admin/auditType/eSave', data)
}

/**
 功能：
 time: 2025-42-02 16:42:10
 **/
export function getAuditTypeDetail(type_id) {
    return api.post('/admin/auditType/getDetail', { type_id })
}

/**
 功能：
 time: 2025-20-02 17:20:52
 **/
export function deleteAuditType(type_id) {
    return api.post('/admin/auditType/del', {type_id})
}

/**
 功能：
 time: 2025-48-03 09:48:06
 **/
export function deleteAllAuditType(typeIds) {
    return api.post('/admin/auditType/delAll', {typeIds})
}

/**
 功能：下拉
 time: 2025-49-03 09:49:03
 **/
export function selectAuditTypeList() {
    return api.get('/admin/auditType/getSelectList')
}

